/**
 * The study apps that feed this map, and Dailies that runs them, one tap away from the system view.
 * Bottom-left; on a phone it sits above the planet strip. Each opens in a new
 * tab so the map stays where it was.
 */
const APPS = [
  { name: 'Dailies', mark: 'يومي', href: 'https://dailies.mappedself.com' },
  { name: 'Tajwid', mark: 'تجويد', href: 'https://tajwid.mappedself.com' },
  { name: 'Ilm', mark: 'علم', href: 'https://ilm.mappedself.com' },
  { name: 'Arabic', mark: 'عربي', href: 'https://arabic.mappedself.com' },
];

export function AppLinks({ mobile }: { mobile: boolean }) {
  return (
    <nav
      aria-label="Study apps"
      className={mobile ? 'absolute left-3 z-10 flex gap-2' : 'absolute bottom-6 left-6 z-10 flex gap-2'}
      style={mobile ? { bottom: 'calc(var(--safe-bottom) + 4.75rem)' } : undefined}
    >
      {APPS.map((app) => (
        <a
          key={app.name}
          href={app.href}
          target="_blank"
          rel="noopener noreferrer"
          title={app.name}
          aria-label={app.name}
          lang="ar"
          dir="rtl"
          className="tap flex h-11 w-11 items-center justify-center rounded-full border border-border text-[13px] leading-none text-text-muted hover:text-text"
          style={{
            fontFamily: 'var(--font-map)',
            background: 'color-mix(in oklch, var(--surface-1) 75%, transparent)',
          }}
        >
          {app.mark}
        </a>
      ))}
    </nav>
  );
}
